export default __webpack_public_path__ + "static/media/adx_logo_black.3fe7d0f5.svg";